export default {
  fromStore(links, ganttInstance) {
    ganttInstance.batchUpdate(() => {
      links.forEach(link => {
        if (!ganttInstance.isTaskExists(link.source) || !ganttInstance.isTaskExists(link.target)) {
          return;
        }

        ganttInstance.silent(() => {
          ganttInstance.addLink({...link});
          ganttInstance.sync_link_create({...link});
        });
      });
    });
  },

  fromGantt(links, ganttInstance) {

  },
};
